import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private sidebarToggled = new Subject<boolean>();
  sidebarToggled$ = this.sidebarToggled.asObservable();

  constructor() { }

  notifySidebarToggle(isCollapsed: boolean) {
    this.sidebarToggled.next(isCollapsed);
    this.refreshTables();
  }

  private refreshTables() {
    // Force table reflow
    setTimeout(() => {
      const tables = document.querySelectorAll('table');
      tables.forEach(table => {
        // Trigger reflow
        table.style.display = 'none';
        table.offsetHeight; // Force reflow
        table.style.display = '';

        // If using DataTables, adjust their layout
        const dataTable = (window as any).$.fn.dataTable.tables({ visible: true, api: true });
        if (dataTable.length > 0) {
          dataTable.forEach((dt: any) => {
            dt.columns.adjust().draw();
          });
        }
      });
    }, 300); // Wait for sidebar animation to complete
  }
} 